import { StatusType } from '../ApplicationPage/types';

export type PublisherType = {
  id: number;
  title: string;
  phone?: string;
  email?: string;
  is_archived?: boolean;
};

export type PublishersType = PublisherType[];

export type LoadingFilesType = FileJsonNamesType[];

export type FileJsonNamesType =
  | 'file_textbook'
  | 'file_guideline'
  | 'file_instruction'
  | 'file_conclusion'
  | 'file_textbook_additional_materials'
  | 'manual_file';

export type TextBookLevelType = {
  id: number;
  title: string;
};

export type TextbookLevelsType = TextBookLevelType[];

export type PublisherTableType = PublisherType & {
  key: number;
};
export type PublishersTableType = PublisherTableType[];

export type ApplicationFormsResponseType = {
  applications: ApplicationFormsType;
  count: number;
};
export type ApplicationFormsType = ApplicationFormType[];

export type ApplicationFormType = {
  id?: number;
  key?: number;
  registration_number: string;
  date: string | null;
  date_created: string;
  fio: string;
  created_at: string;
  updated_at: string;
  phone: string;
  email: string;
  publisher?: PublisherRequestType;
  right_holder: string;
  line_of_textbooks: RulersType | null;
  reason_for_refusal: string;
  is_hidden: boolean;
  status?: {
    id?: number;
    code?: string;
    name?: string;
  };
};

export type PublisherRequestType = {
  id: number;
  title?: string;
  phone?: string;
  email?: string;
};

export type RulerTextbookType = {
  textbooks: BookTextbookType[];
  title: string;
};

export type RulerType = {
  title?: string;
  id?: number;
  textbooks: BooksType;
};

export type RulersType = RulerType[];
export type BooksType = BookType[];

export type SelectedFilesType = {
  instruction_file: string;
};

export type BookApplicationFormType = {
  line_of_textbooks: RulerTextbookType[] | null;
  id?: number;
  key: number;
  registration_number: number;
  date: string | null;
  fio: string;
  created_at: string;
  updated_at: string;
  date_created: string;
  phone: string;
  email: string;
  publisher: PublisherType | null;
  right_holder: string;
  reason_for_refusal: string;
  is_hidden: boolean;
  status: {
    id?: number;
    code?: string;
    name?: string;
  };
};

export type BookTextbookType = BookType & {
  file_textbook?: TextbookFileResponseType;
  file_guideline?: TextbookFileResponseType;
  file_instruction?: TextbookFileResponseType;
  file_textbook_additional_materials?: TextbookFileResponseType[];
  file_conclusion?: TextbookFileResponseType;
};

export type BookManualType = {
  fio?: string;
  file?: FileRequestType;
  title?: string;
};

export type BooksManualType = BookManualType[];

export type BookType = {
  id?: number;
  subject_series?: number;
  subject?: { id: number; title: string };
  subject_series_number?: number;
  text_book_edu_man?: BooksManualType;
  language?: { id: number };
  title: string;
  school_classes: { id: number; title?: string }[];
  author: string;
  right_holder: string;
  year: string;
  region?: { id: number; title?: string };
  date_public_expertise: string;
  adaptive: boolean;
  in_depth_study: boolean;
  publisher?: { id: number; title?: string };
  cartographic_material: boolean;
  hard_copies_present: boolean;
  installation_manual_present: boolean;
  public_expertise: boolean;
  digital_media_present: boolean;
  text_book_level?: {
    id: number;
  };
  teacher_guidelines_present: boolean;
  is_part_of_subject_series: boolean;
  installation_manual_full_title: string;
  teacher_guidelines_full_title: string;
  subject_series_textbooks_titles: string;
  no_edu_lvl_in_number?: boolean;
  file_textbook_endpapers: TextbookFileResponseType[];
  subject_general: {
    id: number;
    title?: string;
    subject_area_general: {
      id: number;
      title?: string;
    };
  };
  link_to_textbook: string;
  comment: string;
  public_expertise_score?: number;
  status?: StatusType;

  file_textbook?: FileRequestType;
  file_guideline?: FileRequestType;
  file_instruction?: FileRequestType;
  file_textbook_additional_materials: FileRequestType[];
  file_conclusion?: FileRequestType;
};

export type FileSendResponse = {
  success: boolean;
  file_id: number;
};

export type FileRequestType = {
  id: number;
  title: string;
  slug?: string;
  file_path?: string;
};

export type FilesContainerType = {
  file_textbook?: TextbookFileResponseType;
  file_guideline?: TextbookFileResponseType;
  file_instruction?: TextbookFileResponseType;
  file_textbook_additional_materials: TextbookFileResponseType[];
  file_conclusion?: TextbookFileResponseType;
  loadType?: string;
};

export type TextbookFileResponseType = {
  id?: number;
  title: string;
  file_path: string;
  base64?: string;
  ext?: string;
  file_id?: number;
};

export type SubjectAreaGeneralType = {
  title: string;
};

export type SubjectAreasGeneralType = SubjectAreaGeneralType[];

export type CreateFileRequestType = {
  title: string;
  base64: string;
  ext: string;
  file_path?: string;
};

export type FileResponseType = {
  id?: number;
  title?: string;
  file_path?: string;
  base64?: string;
};

export type FilesRequestType = FileDataType[];
export type FileDataType = {
  title: string;
  ext: string;
  base64: string;
};

export type DocumentFileDataRequestType = {
  file: { id: number };
  name: string;
  document: { id: number };
  sort: number;
};

export type DocumentFileResponse = {
  success: boolean;
  document_file_id: number;
};

export type SubjectAreaType = {
  title: string;
  id: number;
};

export type SubjectAreaFormType = {
  subject_area_general?: { id: number; title?: string };
  subjects_general: { id: number; title?: string }[];
};

export type SubjectAreasType = SubjectAreaType[];

export type SubjectType = {
  id: number;
  title: string;
  subject_area_general: SubjectAreaType;
};

export type SubjectsType = SubjectType[];

export type LanguageType = {
  id: number;
  title: string;
};

export type LanguagesType = LanguageType[];

export type SchoolClassType = {
  id: string;
  number: number;
  title: string;
};

export const firstCheckboxOptions: { label: string; value: string }[] = [
  {
    label: 'Учебник для реализации адаптированных общеобразовательных программ ',
    value: 'adaptive',
  },
  {
    label: 'Учебник для общеобразовательных программ с углубленным изучением учебных предметов, предметных областей',
    value: 'in_depth_study',
  },
  {
    label: 'Наличие картографического материала',
    value: 'cartographic_material',
  },
];
export type SchoolClassesType = SchoolClassType[];

export type ExpertiseStatusType = {
  id: number;
  name: string;
  code: string;
};

export type ExpertisesStatusType = ExpertiseStatusType[];

export const secondCheckboxOptions: { label: string; value: string }[] = [
  {
    label: 'Учебник направлен в печатном виде',
    value: 'public_expertise',
  },
  {
    label: 'Инструкция по установке, настройке и использованию электронной формы учебника направлена в печатном виде',
    value: 'installation_manual_present',
  },
  {
    label: 'Методическое пособие для учителя направлено в печатном виде',
    value: 'teacher_guidelines_present',
  },
];

export type TextBookSearchType = {
  title: string;
  school_class: number;
  author: string;
  year: number | null;
  search: boolean;
};

export type PaginationType = {
  pagination: number;
  amount: number;
  perPage?: number;
};

export type ValidatorRuleType = {
  right_holder?: boolean;
  fio?: boolean;
  subject_area_general?: boolean;
  subject_general?: boolean;
  title?: boolean;
  year?: boolean;
  school_classes?: boolean;
  file_textbook?: boolean;
  file_guideline?: boolean;
  file_conclusion?: boolean;
  text_book_level?: boolean;
  file_instruction?: boolean;
};

export type TextbookValidatorType = ValidatorRuleType & {
  index: number;
};

export type TextbooksValidatorType = TextbookValidatorType[];

export type RulerValidatorType = {
  [key: number]: TextbooksValidatorType;
};

export type ValidatorsType = RulerValidatorType;

export type ExpertiseSearchType = {
  author?: string;
  year?: string;
  publisher?: number;
  school_class?: number;
  status?: number;
  title?: string;
};
